import React, { Component } from 'react';
import { Row, Col, FormGroup, Input, Label, Button, Table } from 'reactstrap';
import lodash from 'lodash';
import './AddEditFleetVehicle.css';
import CustomSpinner from '../CustomSpinner/CustomSpinner';
import FleetService from '../../services/FleetService';
import ModalService from '../../services/ModalService';
import Validation from '../../services/Validation';
import * as Scroll from 'react-scroll';
import Select from 'react-select'
class AddEditFleetVehicle extends Component {


  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      isMobile: false,
      oldDetail: {},
      MonthlyRunningData: ['<5k', '5k - 6k', '6k - 7k', '7k - 8k', "8k - 9k", '9k - 10k', '>10k'],
      height: '500px',
      controlIndex: 0,
      isDisplayDetail: this.props.isDisplayDetail ? this.props.isDisplayDetail : false,
      controls: {
        vehicle_type: {
          value: 'truck',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        load_type: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        application: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        bias_potential_average_per_month: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
        },
        radial_potential_average_per_month: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        no_of_tube_tyre: {
          value: '',
          valid: null,
          touched: false,
          nullValue: null,
        },
        no_of_tubeless_tyre: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        lead_distance: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        average_mothly_usage: {
          value: "",
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        },
        percentage_retread: {
          value: '',
          valid: null,
          touched: false,
          message: null,
          nullValue: null,
        }
      },
      load_type: ["Normal", "Moderate", "Heavy", "Super Heavy"],
      // leadDistance: ["Short (0-100 KMs)", "Medium (100 - 500 KMs)", , "Long (>500 KMs)"],
      leadDistance: ["Short (0-100 KMs)", "Medium (100 - 500 KMs)", "Long (>500 KMs)"],
      // applications: ["Car Carrier", "2W Carrier", "Tanker", "Cement Carrier", "Bulker - Fly Ash",
      //   "Iron / Steel Carrier", "Mining Dumper", "Ecom Containers", "Market Load Container", "ODC", "Other"],
      applications: [
        { value: 'Car Carrier', label: 'Car Carrier' },
        { value: '2W Carrier', label: '2W Carrier' },
        { value: 'Tanker', label: 'Tanker' },
        { value: 'Cement Carrier', label: 'Cement Carrier' },
        { value: 'Bulker - Fly Ash', label: 'Bulker - Fly Ash' },
        { value: 'Iron / Steel Carrier', label: 'Iron / Steel Carrier' },
        { value: 'Mining Dumper', label: 'Mining Dumper' },
        { value: 'Ecom Containers', label: 'Ecom Containers' },
        { value: 'Market Load Container', label: 'Market Load Container' },
        { value: 'ODC', label: 'ODC' },
        { value: 'Other', label: 'Other' },
      ],
      applicationsBus: [
        { value: 'City Bus', label: 'City Bus' },
        { value: 'Long Haul Bus', label: 'Long Haul Bus' },
        { value: 'Other', label: 'Other' },
      ],
      // applicationsBus: ["City Bus", "Long Haul Bus", "Other"],
      vehicles: {},
      vehicleTypeData: [],
      fleetData: [],
      fleet_id: '',
      countErrorMsg: false,
      countTuched: false,
      biasRadialErrorMsg: false,
      isDisableNoOfTubeAndTubeLess: true,
    }
    // if (props.vehicleData && Object.keys(props.vehicleData).length > 0) {
    //   this.state.vehicles = props.vehicleData.vehicles;
    //   this.state.controls = props.vehicleData.vehicle_detail;
    //   let index = props.vehicleData.vehicle_detail.findIndex(x => x.vehicle_type && x.vehicle_type.value === props.vehicle_type);
    //   if (index > -1) {
    //     this.state.controlIndex = index;
    //   } else {
    //     this.state.controls.push(JSON.parse(JSON.stringify(defaultControls)));
    //     this.state.controls[this.state.controls.length - 1].vehicle_type.value = props.vehicle_type;
    //     this.state.controlIndex = this.state.controls.length - 1;
    //   }
    // } else {
    this.state.vehicles.truck = [
      {
        type: '6_wheeler',
        label: '6 wheeler',
        count: '',
        tyreCount: 6,
      },
      {
        type: '8_wheeler',
        label: '8 wheeler',
        count: '',
        tyreCount: 8,
      },
      {
        type: '10_wheeler',
        label: '10 wheeler',
        count: '',
        tyreCount: 10,
      },
      {
        type: '12_wheeler',
        label: '12 wheeler',
        count: '',
        tyreCount: 12,
      },
      {
        type: '14_wheeler',
        label: '14 wheeler',
        count: '',
        tyreCount: 14,
      },
      {
        type: '16_wheeler',
        label: '16 wheeler',
        count: '',
        tyreCount: 16,
      },
      {
        type: '18_wheeler',
        label: '18 wheeler',
        count: '',
        tyreCount: 18,
      },
      {
        type: '22_wheeler',
        label: '22 wheeler',
        count: '',
        tyreCount: 22,
      }
    ]
    this.state.vehicles.lcv = [
      {
        type: '4_wheeler_lcv',
        label: '4W LCV',
        count: '',
        tyreCount: 4,
      },
      {
        type: '6_wheeler_lcv',
        label: '6W LCV',
        count: '',
        tyreCount: 6,
      },
      {
        type: 'scv',
        label: '4W SCV',
        count: '',
        tyreCount: 4,
      },
      {
        type: 'pickup',
        label: '4W PICKUP',
        count: '',
        tyreCount: 4,
      }
    ]
    this.state.vehicles.scv = [
      {
        type: '4_wheeler',
        label: '4 wheeler',
        count: ''
      },
    ]
    // {
    //   type: '20_wheeler',
    //   label: '20 wheeler',
    //   count: ''
    // },
    // ,
    //   {
    //     type: '28_wheeler',
    //     label: '28 wheeler',
    //     count: '',
    //   }
    // this.state.vehicles.bus = [
    //   {
    //     type: 'two_axles_tube',
    //     tyre_type_lbl: "Tube",
    //     label: 'Two axles',
    //     count: '',
    //     tyre_type: ''
    //   },
    //   {
    //     type: 'two_axles_tube_less',
    //     tyre_type_lbl: "Tube Less",
    //     label: 'Two axles',
    //     count: '',
    //     tyre_type: ''
    //   },
    //   {
    //     type: 'multi_axles_tube',
    //     tyre_type_lbl: "Tube",
    //     label: 'Multi axles',
    //     count: ''
    //   },
    //   {
    //     type: 'multi_axles_tube_less',
    //     tyre_type_lbl: "Tube Less",
    //     label: 'Multi axles',
    //     count: ''
    //   }
    // ]
    this.state.vehicles.bus = [
      {
        type: '6_wheeler',
        // tyre_type_lbl: "Tube",
        label: '6 Wheeler',
        count: '',
        // tyre_type: ''
        tyreCount: 6,
      },
      {
        type: '10_wheeler',
        // tyre_type_lbl: "Tube Less",
        label: 'Premium (10 Wheeler)',
        count: '',
        // tyre_type: '',
        tyreCount: 10,
      },
    ]
    // this.state.vehicles.scv = [
    //   {
    //     type: 'vehicles',
    //     label: 'Vehicles',
    //     count: ''
    //   }
    // ]
    // this.state.vehicles.lcv = [
    //   {
    //     type: 'vehicles',
    //     label: 'Vehicles',
    //     count: ''
    //   }
    // ]
    this.state.vehicles.icv = [
      {
        type: 'vehicles',
        label: 'Vehicles',
        count: ''
      }
    ]
    this.state.vehicles.pickup = [
      {
        type: 'vehicles',
        label: 'Vehicles',
        count: '',
        payload: ''
      }
    ]
    this.state.vehicles.retread = {
      retreading_practice: {
        value: '',
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      major_tread_used: {
        value: '',
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      retreading_franchise: {
        value: '',
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      },
      tyres_per_month: {
        value: '',
        valid: null,
        touched: false,
        message: null,
        nullValue: null,
      }


    }
    //}
  }

  componentDidMount() {
    document.body.style.overflow = 'hidden';
    this.getVehicleType();
    if (!this.props.isAddVehicleDetail) {
      this.getFleetData();
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = 'auto';
  }

  async getVehicleType() {

    try {
      let { vehicleTypeData } = this.state;
      this.setState({ isLoading: true });
      const { data } = await FleetService.getVehicleType();

      if (data) {
        vehicleTypeData = data.data;
      } else {
        vehicleTypeData = [];
      }

      this.setState((prevState) => {
        return { ...prevState, vehicleTypeData, isLoading: false };
      });



    } catch (error) {
      this.setState({ isLoading: false });
      console.log(error);
    }
  }

  closeSideBar = () => {
    this.props.closeSideBar();
  }

  onChangeRetrade = (e) => {
    let controlName = e.target.name;
    let controlValue = e.target.value;
    let { vehicles, controls } = this.state;
    vehicles.retread[controlName].value = controlValue;
    vehicles.retread[controlName].touched = true;
    this.setState({
      controls,
      vehicles
    });
    this.handleValidationRethread();
  }

  async getFleetData() {
    let { fleetData, vehicles, controls, fleet_id, isDisableNoOfTubeAndTubeLess } = this.state;
    try {
      this.setState({
        isLoading: true
      })
      //? 'b371804d-faab-4fb3-aab8-7b4440b0478e' : 'b371804d-faab-4fb3-aab8-7b4440b0478e'

      let data;
      if (this.props.fleet_id) {
        data = await FleetService.getFleetDataProfile(this.props.fleet_id);
      } else {
        data = await FleetService.getFleetData(this.props.uuid);
      }
      data = data.data;

      // const { data } = await FleetService.getFleetData(this.props.uuid);
      let index = data.data.findIndex(x => x.type.toLowerCase() === this.props.vehicle_type);

      if (this.props.vehicle_type === 'retread') {
        fleetData = data.data[index];
        if (Object.keys(fleetData.data[0].number_of_tyres_vehicle_count).length > 0) {
          let number_of_tyres_vehicle_count = fleetData.data[0].number_of_tyres_vehicle_count;
          vehicles.retread.retreading_franchise.value = number_of_tyres_vehicle_count.retreading_franchise;
          vehicles.retread.retreading_practice.value = number_of_tyres_vehicle_count.retreading_practice;
          vehicles.retread.major_tread_used.value = number_of_tyres_vehicle_count.major_tread_used;
          vehicles.retread.tyres_per_month.value = number_of_tyres_vehicle_count.tyres_per_month;
          fleet_id = fleetData.data[0].fleet_id;
        }

      } else {
        if (index > -1) {
          fleetData = data.data[index];
          for (let [key, value] of Object.entries(fleetData.data[0].number_of_tyres_vehicle_count)) {
            if (value) {
              let indexWheel = vehicles[this.props.vehicle_type].findIndex(x => x.type.toLowerCase() === key);
              if (indexWheel > -1) {
                vehicles[this.props.vehicle_type][indexWheel].count = value;
              }
            }
          }

          for (let [key, value] of Object.entries(fleetData.data[0].bias_radial_count)) {
            if (value) {
              if (key === 'radial_potential_average_per_month' || key === 'bias_potential_average_per_month' ||
                key === 'no_of_tube_tyre' || key === 'no_of_tubeless_tyre') {
                if (controls[key]) {
                  controls[key].value = value;
                }

                if (key === 'radial_potential_average_per_month' && value) {
                  isDisableNoOfTubeAndTubeLess = false;
                }
              }
            }
          }

          for (let [key, value] of Object.entries(fleetData.data[0].vehicle_strength_deatil)) {
            if (value) {
              if (controls[key]) {
                controls[key].value = value;
              }

            }
          }
          fleet_id = fleetData.data[0].fleet_id;
        } else {
          fleet_id = '';
        }
      }
      this.setState(prevState => ({
        ...prevState,
        fleetData, vehicles, controls, fleet_id, isLoading: false, isDisableNoOfTubeAndTubeLess
      }));
    } catch (error) {
      this.setState({
        isLoading: false
      })
      console.log(error);
    }
  }

  isPositiveInteger(x) {
    if (!Number.isInteger(x)) {
      return false;
    } else if (x < 0) {
      return false;
    }
    return true;
  }

  onChangeVehicle = (e, type, i = -1) => {
    let controlName = e.target.name;
    let controlValue = e.target.value;
    let { vehicles, controls,
      // controlIndex, 
      countTuched, isDisableNoOfTubeAndTubeLess } = this.state;
    if (controlName === 'count' || controlName === 'payload' || controlName === 'bias_potential_average_per_month'
      || controlName === 'radial_potential_average_per_month' || controlName === 'percentage_retread') {
      if (controlName === 'percentage_retread') {
        controlValue = controlValue.replace(/\./g, "");
        if ((parseInt(controlValue) > -1 && parseInt(controlValue) <= 100) || !controlValue) {
          controlValue = controlValue.replace(/\./g, "");
        } else {
          return
        }
      }
      controlValue = controlValue.replace(/\./g, "");
      if (isNaN(controlValue)) {
        return
      } else {
        if (parseInt(controlValue) < -1) {
          return
        }
        if (controlName === 'radial_potential_average_per_month') {
          isDisableNoOfTubeAndTubeLess = !this.isPositiveInteger(parseInt(controlValue));
        }
      }
    }


    if (i > -1) {
      if (type === 'truck') {
        vehicles.truck[i][controlName] = controlValue;
        countTuched = true;
      } else if (type === 'bus') {
        vehicles.bus[i][controlName] = controlValue;
        countTuched = true;
      } else if (type === 'lcv') {
        vehicles.lcv[i][controlName] = controlValue;
        countTuched = true;
      } else if (type === 'scv') {
        vehicles.scv[i][controlName] = controlValue;
        countTuched = true;
      } else if (type === 'icv') {
        vehicles.icv[i][controlName] = controlValue;
        countTuched = true;
      } else if (type === 'pickup') {
        vehicles.pickup[i][controlName] = controlValue;
        countTuched = true;
      }
    } else {
      controls[controlName].value = controlValue;
      controls[controlName].touched = true;
      // let index = vehicles[type].findIndex((o) => o.type === controlName);
      // if (index > -1) {
      //   vehicles[type][index].value = controlValue;
      //   controls[controlName].value = controlValue;
      // }
    }

    this.setState({
      vehicles,
      controls,
      countTuched,
      isDisableNoOfTubeAndTubeLess
    })
    this.handleValidation(false);
  }

  handleValidationTruck = (isSubmit) => {
    // let { controls } = this.state;
    // let { } = controls;
    // if (activity_type.touched === true || isSubmit) {
    //   activity_type = Validation.notNullValidator(activity_type);
    //   activity_type.valid = !activity_type.nullValue;
    //   if (activity_type.valid === false) {
    //     activity_type.showErrorMsg = true;
    //   } else {
    //     activity_type.showErrorMsg = false;
    //   }
    // }
  }

  async proceedToSave(currentFleetData) {
    try {
      this.setState({
        isLoading: true
      })

      let data;
      if (this.props.fleet_id) {
        data = await FleetService.postFleetRegistrationProfile(currentFleetData);
      } else {
        data = await FleetService.postFleetRegistration(currentFleetData);
      }
      data = data.data;

      // const { data } = await FleetService.postFleetRegistration(currentFleetData);

      if (data.success) {
        // ModalService.openAlert('', messages.FLEET_REGISTRATION.SUCCESSREGISTRATION, 'success');
        this.props.submitVehclies(
          {
            vehicles: lodash.cloneDeep(this.state.vehicles)
          }
        )
      }
      this.setState({
        isLoading: false
      })
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      this.setState({
        isLoading: false
      })
    }
    // if (param !== 'doNotRedirectToProfile') {
    //   this.props.buildMyFleetClick(false);
    // } else {
    //   this.getFleetData();
    // }
  }

  handleValidation = (isSubmit = false) => {
    let { countErrorMsg, vehicles, controls, countTuched } = this.state;
    let { bias_potential_average_per_month, radial_potential_average_per_month, no_of_tube_tyre, no_of_tubeless_tyre,
      average_mothly_usage, application, load_type, lead_distance, percentage_retread } = controls;
    let isValidForm = false;
    if (this.props.vehicle_type === 'truck' && (countTuched || isSubmit)) {
      let totalCountTruck = lodash.sumBy(vehicles.truck, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountTruck <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    } else if (this.props.vehicle_type === 'bus' && (countTuched || isSubmit)) {
      let totalCountBus = lodash.sumBy(vehicles.bus, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountBus <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    } else if (this.props.vehicle_type === 'scv' && (countTuched || isSubmit)) {
      let totalCountScv = lodash.sumBy(vehicles.scv, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountScv <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    } else if (this.props.vehicle_type === 'lcv' && (countTuched || isSubmit)) {
      let totalCountLcv = lodash.sumBy(vehicles.lcv, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountLcv <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    } else if (this.props.vehicle_type === 'icv' && (countTuched || isSubmit)) {
      let totalCountIcv = lodash.sumBy(vehicles.icv, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountIcv <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    } else if (this.props.vehicle_type === 'pickup' && (countTuched || isSubmit)) {
      let totalCountPickup = lodash.sumBy(vehicles.pickup, function (o) {
        if (o.count) {
          return +o.count;
        } else {
          return 0;
        }
      });
      if (totalCountPickup <= 0) {
        countErrorMsg = true;
      } else {
        countErrorMsg = false;
      }
    }
    bias_potential_average_per_month.valid = true;
    radial_potential_average_per_month.valid = true;
    radial_potential_average_per_month.showErrorMsg = false;
    bias_potential_average_per_month.showErrorMsg = false;
    if ((bias_potential_average_per_month.touched === true || isSubmit) && (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'retreade' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv')) {
      bias_potential_average_per_month = Validation.notNullValidator(bias_potential_average_per_month);
      bias_potential_average_per_month.valid = !bias_potential_average_per_month.nullValue;
      if (bias_potential_average_per_month.valid === false) {
        bias_potential_average_per_month.showErrorMsg = true;
      } else {
        bias_potential_average_per_month.showErrorMsg = false;
      }
    }

    if ((radial_potential_average_per_month.touched === true || isSubmit) && (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'retreade' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv')) {
      radial_potential_average_per_month = Validation.notNullValidator(radial_potential_average_per_month);
      radial_potential_average_per_month.valid = !radial_potential_average_per_month.nullValue;
      if (radial_potential_average_per_month.valid === false) {
        radial_potential_average_per_month.showErrorMsg = true;
      } else {
        radial_potential_average_per_month.showErrorMsg = false;
      }
    }

    percentage_retread.valid = true;
    percentage_retread.showErrorMsg = false;
    // if ((percentage_retread.touched === true || isSubmit) && (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv')) {
    //   percentage_retread = Validation.notNullValidator(percentage_retread);
    //   percentage_retread.valid = !percentage_retread.nullValue;
    //   if (percentage_retread.valid === false) {
    //     percentage_retread.showErrorMsg = true;
    //   } else {
    //     percentage_retread.showErrorMsg = false;
    //   }
    // }

    if (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv') {
      application.valid = true;
      application.showErrorMsg = false;
      lead_distance.valid = true;
      lead_distance.showErrorMsg = false;
      load_type.valid = true;
      load_type.showErrorMsg = false;
      average_mothly_usage.valid = true;
      average_mothly_usage.showErrorMsg = false;
    }

    if ((application.touched === true || isSubmit) && (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv')) {
      application = Validation.notNullValidator(application);
      application.valid = !application.nullValue;
      if (application.valid === false) {
        application.showErrorMsg = true;
      } else {
        application.showErrorMsg = false;
      }
    }

    if ((load_type.touched === true || isSubmit) && (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv')) {
      load_type = Validation.notNullValidator(load_type);
      load_type.valid = !load_type.nullValue;
      if (load_type.valid === false) {
        load_type.showErrorMsg = true;
      } else {
        load_type.showErrorMsg = false;
      }
    }

    if ((lead_distance.touched === true || isSubmit) && (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv')) {
      lead_distance = Validation.notNullValidator(lead_distance);
      lead_distance.valid = !lead_distance.nullValue;
      if (lead_distance.valid === false) {
        lead_distance.showErrorMsg = true;
      } else {
        lead_distance.showErrorMsg = false;
      }
    }


    if ((average_mothly_usage.touched === true || isSubmit) && (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv')) {
      average_mothly_usage = Validation.notNullValidator(average_mothly_usage);
      average_mothly_usage.valid = !average_mothly_usage.nullValue;
      if (average_mothly_usage.valid === false) {
        average_mothly_usage.showErrorMsg = true;
      } else {
        average_mothly_usage.showErrorMsg = false;
      }
    }


    no_of_tube_tyre.valid = true;
    no_of_tubeless_tyre.valid = true;
    no_of_tube_tyre.showErrorMsg = false;
    no_of_tubeless_tyre.showErrorMsg = false;
    if ((no_of_tube_tyre.touched === true || isSubmit) && (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'retreade' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv')) {
      no_of_tube_tyre = Validation.notNullValidator(no_of_tube_tyre);
      no_of_tube_tyre.valid = !no_of_tube_tyre.nullValue;
      if (radial_potential_average_per_month.value && no_of_tube_tyre.valid === false) {
        no_of_tube_tyre.showErrorMsg = true;
      } else {
        no_of_tube_tyre.showErrorMsg = false;
      }
    }

    if ((no_of_tubeless_tyre.touched === true || isSubmit) && (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'retreade' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv')) {
      no_of_tubeless_tyre = Validation.notNullValidator(no_of_tubeless_tyre);
      no_of_tubeless_tyre.valid = !no_of_tubeless_tyre.nullValue;
      if (radial_potential_average_per_month.value && no_of_tubeless_tyre.valid === false) {
        no_of_tubeless_tyre.showErrorMsg = true;
      } else {
        no_of_tubeless_tyre.showErrorMsg = false;
      }
    }



    if (((radial_potential_average_per_month.valid || bias_potential_average_per_month.valid))
      && countErrorMsg === false && lead_distance.valid &&
      load_type.valid && application.valid && average_mothly_usage.valid && percentage_retread.valid) {
      if (!radial_potential_average_per_month.nullValue) {
        if ((no_of_tube_tyre.valid || no_of_tubeless_tyre.valid)) {
          isValidForm = true;
        } else {
          isValidForm = false;
        }
      } else {
        isValidForm = true;
      }
    } else {
      isValidForm = false;
    }

    if ((!lead_distance.valid || !load_type.valid || !application.valid || !average_mothly_usage.valid) && isSubmit) {
      this.scrollTo('vehicle-strength');
    } else if ((countErrorMsg === true || (radial_potential_average_per_month.showErrorMsg || bias_potential_average_per_month.showErrorMsg)) && isSubmit) {
      this.scrollTo('BiasPotintailAvg');
    } else if (percentage_retread.valid === false) {
      this.scrollTo('percentage_retread');
    }
    this.setState({
      countErrorMsg,
      controls
    })

    return isValidForm;
  }



  scrollTo(id) {
    let scroller = Scroll.scroller;
    scroller.scrollTo(id, {
      duration: 1000,
      delay: 100,
      smooth: "easeInOutQuint",
      offset: -120,
      containerId: 'ScrollElement',
    })
  }


  handleValidationRethread = (isSubmit = false) => {
    let { vehicles } = this.state;
    let { tyres_per_month, retreading_practice, retreading_franchise, major_tread_used } = vehicles.retread;
    let isValidForm = false;
    if (retreading_practice.touched === true || isSubmit) {
      retreading_practice = Validation.notNullValidator(retreading_practice);
      retreading_practice.valid = !retreading_practice.nullValue;
      if (retreading_practice.valid === false) {
        retreading_practice.showErrorMsg = true;
      } else {
        retreading_practice.showErrorMsg = false;
      }
    }
    if ((retreading_franchise.touched === true || isSubmit) && retreading_practice.value === 'retreads') {
      retreading_franchise = Validation.notNullValidator(retreading_franchise);
      retreading_franchise.valid = !retreading_franchise.nullValue;
      if (retreading_franchise.valid === false) {
        retreading_franchise.showErrorMsg = true;
      } else {
        retreading_franchise.showErrorMsg = false;
      }
    } else {
      retreading_franchise.showErrorMsg = false;
      retreading_franchise.valid = true;
    }

    if ((major_tread_used.touched === true || isSubmit) && retreading_practice.value === 'retreads') {
      major_tread_used = Validation.notNullValidator(major_tread_used);
      major_tread_used.valid = !major_tread_used.nullValue;
      if (major_tread_used.valid === false) {
        major_tread_used.showErrorMsg = true;
      } else {
        major_tread_used.showErrorMsg = false;
      }
    } else {
      major_tread_used.showErrorMsg = false;
      major_tread_used.valid = true;
    }

    if ((tyres_per_month.touched === true || isSubmit) && retreading_practice.value === 'retreads') {
      tyres_per_month = Validation.notNullValidator(tyres_per_month);
      tyres_per_month.valid = !tyres_per_month.nullValue;
      if (tyres_per_month.valid === false) {
        tyres_per_month.showErrorMsg = true;
      } else {
        tyres_per_month.showErrorMsg = false;
      }
    } else {
      tyres_per_month.showErrorMsg = false;
      tyres_per_month.valid = true;
    }

    if (retreading_practice.valid && tyres_per_month.valid === true) {
      isValidForm = true;
    }
    this.setState({
      vehicles
    });
    return isValidForm;
  }

  submit = () => {
    let { vehicles, controls } = this.state;

    // let testData = this.getTotalWheel();

    if (this.props.vehicle_type === 'retread') {
      if (!this.handleValidationRethread(true)) {
        return
      }
    } else {
      if (!this.handleValidation(true)) {
        return
      }
    }

    let totalTruckTyres = lodash.sumBy(vehicles.truck, o => o.count * o.tyreCount);
    let totalBusTyres = lodash.sumBy(vehicles.bus, o => o.count * o.tyreCount);
    let totalScVTyres = lodash.sumBy(vehicles.scv, o => o.count * o.tyreCount);
    let totalLcVTyres = lodash.sumBy(vehicles.lcv, o => o.count * o.tyreCount);
    let totalIcVTyres = lodash.sumBy(vehicles.icv, o => o.count * o.tyreCount);
    let totalPickupTyres = lodash.sumBy(vehicles.pickup, o => o.count * o.tyreCount);

    let totalCountTruck = lodash.sumBy(vehicles.truck, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountBus = lodash.sumBy(vehicles.bus, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountScv = lodash.sumBy(vehicles.scv, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountLcv = lodash.sumBy(vehicles.lcv, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountIcv = lodash.sumBy(vehicles.icv, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountPickup = lodash.sumBy(vehicles.pickup, function (o) {
      if (o.count) {
        return +o.count;
      } else {
        return 0;
      }
    });
    let totalCountRetread = 0;
    if (this.state.vehicles.retread && Object.keys(this.state.vehicles.retread).length > 0) {
      if (this.state.vehicles.retread.tyres_per_month.value) {
        totalCountRetread = +this.state.vehicles.retread.tyres_per_month.value;
      }
    }

    let reqData = {};
    let number_of_tyres_vehicle_count = {};
    let vehicle_strength_deatil = {};
    if (this.props.vehicle_type === 'retread') {
      number_of_tyres_vehicle_count = {
        retreading_practice: this.state.vehicles.retread.retreading_practice.value,
        retreading_franchise: this.state.vehicles.retread.retreading_practice.value !== 'sells casings' ? this.state.vehicles.retread.retreading_franchise.value : '',
        major_tread_used: this.state.vehicles.retread.retreading_practice.value !== 'sells casings' ? this.state.vehicles.retread.major_tread_used.value : '',
        tyres_per_month: this.state.vehicles.retread.retreading_practice.value !== 'sells casings' ? (this.state.vehicles.retread.tyres_per_month.value ? parseInt(this.state.vehicles.retread.tyres_per_month.value) : '') : '',
      }
    }
    else if (this.props.vehicle_type === 'bus') {

      let six_wheel = 0, ten_wheel = 0;
      let { vehicles } = this.state;
      if (vehicles.bus[0].count) {
        six_wheel = vehicles.bus[0].count ? parseInt(vehicles.bus[0].count) : 0;
      }
      if (vehicles.bus[1].count) {
        ten_wheel += vehicles.bus[1].count ? parseInt(vehicles.bus[1].count) : 0;
      }
      // if (vehicles.bus[2].count) {
      //   ten_wheel = vehicles.bus[2].count ? parseInt(vehicles.bus[2].count) : 0;
      // }
      // if (vehicles.bus[3].count) {
      //   ten_wheel += vehicles.bus[3].count ? parseInt(vehicles.bus[3].count) : 0;
      // }
      if (six_wheel <= 0 && ten_wheel <= 0) {
        ModalService.openAlert('', "Please enter count", 'error');
        return
      }
      number_of_tyres_vehicle_count = {
        '6_wheeler': vehicles.bus[0].count ? parseInt(vehicles.bus[0].count) : 0,
        '10_wheeler': vehicles.bus[1].count ? parseInt(vehicles.bus[1].count) : 0,
        // two_axles_tube: vehicles.bus[0].count ? parseInt(vehicles.bus[0].count) : 0,
        // two_axles_tube_less: vehicles.bus[1].count ? parseInt(vehicles.bus[1].count) : 0,
        // multi_axles_tube: vehicles.bus[2].count ? parseInt(vehicles.bus[2].count) : 0,
        // multi_axles_tube_less: vehicles.bus[3].count ? parseInt(vehicles.bus[3].count) : 0,
        // '6_wheeler': six_wheel,
        // '10_wheeler': ten_wheel
      }
      Object.keys(this.state.controls).forEach(element => {
        if (element === 'vehicle_type') {
          vehicle_strength_deatil['vehicle_type'] = this.props.vehicle_type;
        } else {
          vehicle_strength_deatil[element] = this.state.controls[element].value ? this.state.controls[element].value : 0;
        }
      });
    }
    else {
      this.state.vehicles[this.props.vehicle_type].forEach(element => {
        if (element.count) {
          number_of_tyres_vehicle_count[element.type] = parseInt(element.count);
        } else {
          number_of_tyres_vehicle_count[element.type] = 0;
        }
      });

      if (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv') {
        Object.keys(this.state.controls).forEach(element => {
          if (element === 'vehicle_type') {
            vehicle_strength_deatil['vehicle_type'] = this.props.vehicle_type;
          } else {
            vehicle_strength_deatil[element] = this.state.controls[element].value ? this.state.controls[element].value : 0;
          }

        });
      } else if (this.props.vehicle_type !== 'retread') {
        Object.keys(this.state.controls).forEach(element => {
          if (element === 'average_mothly_usage') {
            vehicle_strength_deatil[element] = this.state.controls[element].value ? this.state.controls[element].value : 0;
          }
        });
      }
    }
    reqData.number_of_tyres_vehicle_count = number_of_tyres_vehicle_count;
    if (this.props.vehicle_type === 'truck') {
      reqData.count = totalCountTruck;
      reqData.total_tyre = totalTruckTyres;
    } else if (this.props.vehicle_type === 'bus') {
      reqData.count = totalCountBus;
      reqData.total_tyre = totalBusTyres;
    } else if (this.props.vehicle_type === 'scv') {
      reqData.count = totalCountScv;
      reqData.total_tyre = totalScVTyres;
    } else if (this.props.vehicle_type === 'lcv') {
      reqData.count = totalCountLcv;
      reqData.total_tyre = totalLcVTyres;
    } else if (this.props.vehicle_type === 'icv') {
      reqData.count = totalCountIcv;
      reqData.total_tyre = totalIcVTyres;
    } else if (this.props.vehicle_type === 'pickup') {
      reqData.count = totalCountPickup;
      reqData.total_tyre = totalPickupTyres;
    } else if (this.props.vehicle_type === 'retread') {
      reqData.count = totalCountRetread;
      reqData.total_tyre = totalTruckTyres;
    }

    if (this.props.uuid) {
      reqData.temp_id = this.props.uuid;
    }
    reqData.vehicle_strength_deatil = vehicle_strength_deatil;
    if (this.props.vehicle_type !== 'truck' && this.props.vehicle_type !== 'bus' && this.props.vehicle_type !== 'retread' && this.props.vehicle_type !== 'lcv' && this.props.vehicle_type !== 'scv') {
      reqData.bias_radial_count = {
        bias_potential_average_per_month: controls.bias_potential_average_per_month.value ? parseInt(controls.bias_potential_average_per_month.value) : 0,
        radial_potential_average_per_month: controls.radial_potential_average_per_month.value ? parseInt(controls.radial_potential_average_per_month.value) : 0,
        no_of_tube_tyre: 0,
        no_of_tubeless_tyre: 0,
      };
      if (controls.radial_potential_average_per_month.value) {
        reqData.bias_radial_count.no_of_tubeless_tyre = controls.no_of_tubeless_tyre.value ? parseInt(controls.no_of_tubeless_tyre.value) : 0;
        reqData.bias_radial_count.no_of_tube_tyre = controls.no_of_tube_tyre.value ? parseInt(controls.no_of_tube_tyre.value) : 0
      }
    }
    if (this.state.vehicleTypeData.length > 0) {
      this.state.vehicleTypeData.forEach(element => {
        if (element.name.toLowerCase() === this.props.vehicle_type) {
          reqData.vehicle_type_id = element.vehicle_type_id;
        }
      });
    } else {
      return
    }

    reqData.fleet_id = this.props.fleet_id;

    if (this.state.fleet_id) {
      reqData.fleet_id = this.state.fleet_id;
      this.proceedToUpdate(reqData);
    } else {
      this.proceedToSave(reqData);
    }
  }

  proceedToUpdate = async (obj) => {

    try {
      this.setState({
        isLoading: true
      })

      let data;
      if (this.props.fleet_id) {
        data = await FleetService.updateFleetProfile(obj);
      } else {
        data = await FleetService.updateFleet(obj);
      }
      data = data.data;

      // const { data } = await FleetService.updateFleet(obj);

      if (data.success) {
        // ModalService.openAlert('', messages.FLEET_REGISTRATION.UPDATEREGISTRATION, 'success');
        this.props.submitVehclies(
          {
            vehicles: lodash.cloneDeep(this.state.vehicles)
          }
        )
      }
      this.setState({
        isLoading: false
      })
    } catch (e) {
      if (e.response && e.response.data && e.response.data.error && e.response.data.error.length > 0) {
        ModalService.openAlert('', e.response.data.error[0].message, 'error');
      }
      this.setState({
        isLoading: false
      })
    }
    // if (param !== 'doNotRedirectToProfile') {
    //   this.props.buildMyFleetClick(false);
    // }
  }

  handleInputChange = (e) => {
    const controlName = e.target.name;
    const controlValue = e.target.value;
    const { controls } = this.state;
    controls[controlName].value = controlValue;
    this.setState({ controls });
  }

  getTotalTyre = (vehicleArr) => {
    let sum = 0;

    for (let i = 0; i < vehicleArr.length; i++) {
      if (vehicleArr[i].count !== "") {
        sum += vehicleArr[i].count * vehicleArr[i].tyreCount;
      }
    }
    // getTotalWheel(sum);
    return sum;
  }

  render() {
    let { controls, vehicles, MonthlyRunningData } = this.state;
    if (this.props.vehicle_type === 'truck' || this.props.vehicle_type === 'bus' || this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv') {
      MonthlyRunningData = [

        '2k - 3k', '3k - 4k', '4k - 5k', '5k - 6k', '6k - 7k', '7k - 8k', '8k - 9k',
        '9k - 10k', '10k - 12k', '12k - 15k', '15k - 20k', '>20k'
      ]
    }
    return (
      <>
        <div class="custom-drawer" id="AddEditActivity">
          {this.state.isLoading && <CustomSpinner></CustomSpinner>}
          {/* <CustomSpinner/> */}
          <div style={{ marginTop: this.props.from !== 'on-boarding' ? '60px' : '0px' }}>
            <div className="drawer-header">
              <div className="d-flex-row">
                {
                  this.state.isDisplayDetail &&
                  <div>
                    <img src="images/left.svg" alt='left' className="cursor-pointer" onClick={this.closeSideBar} />
                    &nbsp;&nbsp;
                    <Label
                      className="link-warm-blue cursor-pointer"
                      style={{
                        fontSize: "18px",
                        fontWeight: "normal",
                        marginTop: "5px"
                      }}
                      onClick={() => this.closeSideBar()}
                    >
                      Back
                    </Label>
                  </div>
                }
                <span className="drawer-title mt-auto mb-auto" style={{ marginLeft: this.state.isDisplayDetail ? '8px' : '0px' }}>
                  {/* {this.props.vehicle_type === 'retread' 
                  ? 'retread detail' 
                  : (this.props.vehicle_type === 'lcv' 
                  ? 'LCV / SCV / PICKUP Details' 
                  : this.props.vehicle_type + ' Vehicle Detail')
                  } */}
                  {this.props.vehicle_type === 'retread'
                    ? 'retread Details'
                    : (this.props.vehicle_type === 'lcv'
                      ? 'LCV / SCV / PICKUP Vehicle Details'
                      : (this.props.vehicle_type === 'truck'
                        ? 'Truck ( ICV/ MHCV) Vehicle Details'
                        : this.props.vehicle_type + ' Vehicle Details')
                    )
                  }
                </span>
              </div>
              {
                !this.state.isDisplayDetail &&
                <img className="cursor-pointer" src="images/close.svg" alt='cancel' onClick={this.closeSideBar} />
              }
            </div>
            <hr style={{ border: 'solid 1px #ced4da' }} />
          </div>
          <div class="custom-drawer-content" name='ScrollElement' id="ScrollElement">
            {
              this.props.vehicle_type === 'truck' &&
              <>
                <Row style={{ margin: '3px' }} id="vehicle-strength">
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Most used Application<span className="required-field">*</span></Label>
                      {/* <select className="form-control" name="application" value={controls.application.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck', -1)}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.applications.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select> */}
                      <Select
                        options={this.state.applications}
                        closeMenuOnSelect={false}
                        value={controls.application.value}
                        onChange={(e) => this.handleInputChange({ target: { name: 'application', value: e } })}
                        isMulti />
                      {controls.application.showErrorMsg && <div className="error">*Please select most used application.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">General Loading Pattern<span className="required-field">*</span></Label>
                      <select className="form-control" name="load_type" value={controls.load_type.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.load_type.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>
                              {MonthlyRunning === 'Normal' && 'Normal (100%)'}
                              {MonthlyRunning === 'Moderate' && 'Moderate (101% to 140%)'}
                              {MonthlyRunning === 'Heavy' && 'Heavy (141% to 160%)'}
                              {MonthlyRunning === 'Super Heavy' && 'Super Heavy (160%)'}
                            </option>
                          ))
                        }
                      </select>
                      {controls.load_type.showErrorMsg && <div className="error">*Please select general loading pattern.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Lead Distance<span className="required-field">*</span></Label>
                      <select className="form-control" name="lead_distance" value={controls.lead_distance.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.leadDistance.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.lead_distance.showErrorMsg && <div className="error">*Please select avg lead distance.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Monthly running(KMs)<span className="required-field">*</span></Label>
                      <select className="form-control" name="average_mothly_usage" value={controls.average_mothly_usage.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')}>
                        <option value="" selected>Select</option>
                        {
                          MonthlyRunningData.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning ? MonthlyRunning.toLowerCase() : ''} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.average_mothly_usage.showErrorMsg && <div className="error">*Please select avg monthly running.</div>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="10" md="12" xs="12">
                    <Table className="mb-0 table-responsive tbl-count">
                      <thead>
                        <tr>
                          <th style={{ border: 'none', width: '30%' }}>Type</th>
                          <th style={{ border: 'none' }}><span style={{ marginLeft: '45px' }}>Count</span><span className="required-field">*</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          vehicles.truck.map((vehicle_type, i) => (
                            (vehicle_type.type !== 'lead_type' && vehicle_type.type !== "bias_potential_average_per_month" &&
                              vehicle_type.type !== 'radial_potential_average_per_month' && vehicle_type.type !== 'load_type' &&
                              vehicle_type.type !== 'lead_distance' && vehicle_type.type !== 'application') &&
                            <tr>
                              <td className="text-align-left">
                                <Label for="owner_name" style={{ fontWeight: 'normal' }}
                                  className="mt-xl-3">{vehicle_type.label}</Label>
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  autocomplete="nofill"
                                  name="count"
                                  disabled={this.state.isDisplayDetail}
                                  value={vehicle_type.count}
                                  style={{ width: '100px', marginLeft: '45px' }}
                                  onChange={(e) => this.onChangeVehicle(e, 'truck', i)}
                                  placeholder=" " />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                    {this.state.countErrorMsg && <div className="error" style={{ marginLeft: '185px' }}>*Please enter count</div>}
                  </Col>
                </Row>

                <Col xs="12">
                  <Row>
                    <Col xs="12">
                      <hr />
                      <div>
                        <Label for="company_name" className="mt-xl-2 font-weight-bold" style={{ width: '37%', paddingLeft: '7px' }}>Total number of Wheels<span className="required-field">*</span></Label>
                        {this.getTotalTyre(vehicles.truck)}
                      </div>
                    </Col>
                  </Row>
                </Col>
                {/* <Row id="percentage_retread" style={{ borderTop: 'solid 1px #ced4da', margin: '3px' }}>
                  <Col xl="12" md="12" xs="12" className="mt-3">
                    <Row>
                      <Col xl="4" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Retreading %<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="percentage_retread"
                            value={controls.percentage_retread.value}
                            style={{ width: '100px' }}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                          {controls.percentage_retread.showErrorMsg && <div className="error">*Please enter retreading %.</div>}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
              </>
            }
            {
              this.props.vehicle_type === 'bus' &&
              <>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Most used Application <span className="required-field">*</span></Label>
                      {/* <select className="form-control" name="application" value={controls.application.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck', -1)}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.applicationsBus.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select> */}
                      <Select
                        options={this.state.applicationsBus}
                        disabled={this.state.isDisplayDetail}
                        closeMenuOnSelect={false}
                        value={controls.application.value}
                        onChange={(e) => this.handleInputChange({ target: { name: 'application', value: e } })}
                        isMulti />
                      {controls.application.showErrorMsg && <div className="error">*Please select most used application.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">General Loading Pattern<span className="required-field">*</span></Label>
                      <select className="form-control" name="load_type" value={controls.load_type.value}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')} disabled={this.state.isDisplayDetail}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.load_type.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>
                              {MonthlyRunning === 'Normal' && 'Normal (100%)'}
                              {MonthlyRunning === 'Moderate' && 'Moderate (101% to 140%)'}
                              {MonthlyRunning === 'Heavy' && 'Heavy (141% to 160%)'}
                              {MonthlyRunning === 'Super Heavy' && 'Super Heavy (160%)'}
                            </option>
                          ))
                        }
                      </select>
                      {controls.load_type.showErrorMsg && <div className="error">*Please select general loading pattern.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Lead Distance<span className="required-field">*</span> </Label>
                      <select className="form-control" name="lead_distance" value={controls.lead_distance.value}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')} disabled={this.state.isDisplayDetail}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.leadDistance.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.lead_distance.showErrorMsg && <div className="error">*Please select avg lead distance.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Monthly running(KMs)<span className="required-field">*</span></Label>
                      <select className="form-control" name="average_mothly_usage" value={controls.average_mothly_usage.value}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')} disabled={this.state.isDisplayDetail}>
                        <option value="" selected>Select</option>
                        {
                          MonthlyRunningData.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.average_mothly_usage.showErrorMsg && <div className="error">*Please select avg monthly running.</div>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="12" md="12" xs="12">
                    <Table className="mb-0 table-responsive tbl-count">
                      <thead>
                        <tr>
                          <th style={{ border: 'none', width: '40%' }}>Type</th>
                          {/* <th style={{ border: 'none' }}>Tyre Type</th> */}
                          <th style={{ border: 'none' }}>Count<span className="required-field">*</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          vehicles.bus.map((vehicle_type, i) => (
                            (vehicle_type.type !== 'lead_type' && vehicle_type.type !== "bias_potential_average_per_month" &&
                              vehicle_type.type !== 'radial_potential_average_per_month') &&
                            <tr>
                              <td className="text-align-left">
                                <Label for="owner_name" className="font-weight-normal mt-xl-3">{vehicle_type.label}</Label>
                              </td>
                              {/* <td className="text-align-left">
                                <Label for="owner_name" className="font-weight-normal mt-xl-3">{vehicle_type.tyre_type_lbl}</Label>
                              </td> */}
                              <td>
                                <Input
                                  type="text"
                                  autocomplete="nofill"
                                  name="count"
                                  value={vehicle_type.count}
                                  onChange={(e) => this.onChangeVehicle(e, 'bus', i)}
                                  disabled={this.state.isDisplayDetail}
                                  placeholder=" " />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                    {this.state.countErrorMsg && <div className="error" style={{ marginLeft: '285px', marginTop: '0px' }}>*Please enter count</div>}
                  </Col>

                  <Col xs="12">
                    <Row>
                      <Col xs="12">
                        <hr />
                        <div>
                          <Label for="company_name" className="mt-xl-2 font-weight-bold" style={{ width: '42%', paddingLeft: '7px' }}>Total number of Wheels<span className="required-field">*</span></Label>
                          {this.getTotalTyre(vehicles.bus)}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                </Row>
                {/* <Row id="percentage_retread" style={{ borderTop: 'solid 1px #ced4da', margin: '3px' }}>
                  <Col xl="12" md="12" xs="12" className="mt-3">
                    <Row>
                      <Col xl="6" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Retreading %<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="percentage_retread"
                            value={controls.percentage_retread.value}
                            style={{ marginLeft: '-5px' }}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                          {controls.percentage_retread.showErrorMsg && <div className="error">*Please enter retreading %.</div>}
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
                {/* <Row id="AddEditFleetVehicle" style={{ borderTop: 'solid 1px #ced4da', margin: '3px' }}>
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="6" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">% Radialisation<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="bias_potential_average_per_month"
                            value={controls.bias_potential_average_per_month.value}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                </Row> */}
              </>
            }
            {
              (this.props.vehicle_type === 'lcv' || this.props.vehicle_type === 'scv') &&
              <>
                <Row style={{ margin: '3px' }} id="vehicle-strength">
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Most used Application<span className="required-field">*</span></Label>
                      {/* <select className="form-control" name="application" value={controls.application.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, 'truck', -1)}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.applications.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select> */}
                      <Select
                        options={this.state.applications}
                        closeMenuOnSelect={false}
                        value={controls.application.value}
                        onChange={(e) => this.handleInputChange({ target: { name: 'application', value: e } })}
                        isMulti />
                      {controls.application.showErrorMsg && <div className="error">*Please select most used application.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">General Loading Pattern<span className="required-field">*</span></Label>
                      <select className="form-control" name="load_type" value={controls.load_type.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.load_type.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>
                              {MonthlyRunning === 'Normal' && 'Normal (100%)'}
                              {MonthlyRunning === 'Moderate' && 'Moderate (101% to 140%)'}
                              {MonthlyRunning === 'Heavy' && 'Heavy (141% to 160%)'}
                              {MonthlyRunning === 'Super Heavy' && 'Super Heavy (160%)'}
                            </option>
                          ))
                        }
                      </select>
                      {controls.load_type.showErrorMsg && <div className="error">*Please select general loading pattern.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Lead Distance<span className="required-field">*</span></Label>
                      <select className="form-control" name="lead_distance" value={controls.lead_distance.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}>
                        <option value="" selected disabled>Select</option>
                        {
                          this.state.leadDistance.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.lead_distance.showErrorMsg && <div className="error">*Please select avg lead distance.</div>}
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Monthly running(KMs)<span className="required-field">*</span></Label>
                      <select className="form-control" name="average_mothly_usage" value={controls.average_mothly_usage.value}
                        disabled={this.state.isDisplayDetail}
                        onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}>
                        <option value="" selected>Select</option>
                        {
                          MonthlyRunningData.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning ? MonthlyRunning.toLowerCase() : ''} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                      {controls.average_mothly_usage.showErrorMsg && <div className="error">*Please select avg monthly running.</div>}
                    </FormGroup>
                  </Col>
                </Row>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="10" md="12" xs="12">
                    <Table className="mb-0 table-responsive tbl-count">
                      <thead>
                        <tr>
                          <th style={{ border: 'none', width: '30%' }}>Vehicle Type</th>
                          <th style={{ border: 'none' }}><span style={{ marginLeft: '45px' }}>Count</span><span className="required-field">*</span></th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          this.props.vehicle_type === 'lcv' && vehicles.lcv.map((vehicle_type, i) => (
                            (vehicle_type.type !== 'lead_type' && vehicle_type.type !== "bias_potential_average_per_month" &&
                              vehicle_type.type !== 'radial_potential_average_per_month' && vehicle_type.type !== 'load_type' &&
                              vehicle_type.type !== 'lead_distance' && vehicle_type.type !== 'application') &&
                            <tr>
                              <td className="text-align-left">
                                <Label for="owner_name" style={{ fontWeight: 'normal' }}
                                  className="mt-xl-3">{vehicle_type.label}</Label>
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  autocomplete="nofill"
                                  name="count"
                                  disabled={this.state.isDisplayDetail}
                                  value={vehicle_type.count}
                                  style={{ width: '100px', marginLeft: '45px' }}
                                  onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type, i)}
                                  placeholder=" " />
                              </td>
                            </tr>
                          ))
                        }
                        {
                          this.props.vehicle_type === 'scv' && vehicles.scv.map((vehicle_type, i) => (
                            (vehicle_type.type !== 'lead_type' && vehicle_type.type !== "bias_potential_average_per_month" &&
                              vehicle_type.type !== 'radial_potential_average_per_month' && vehicle_type.type !== 'load_type' &&
                              vehicle_type.type !== 'lead_distance' && vehicle_type.type !== 'application') &&
                            <tr>
                              <td className="text-align-left">
                                <Label for="owner_name" style={{ fontWeight: 'normal' }}
                                  className="mt-xl-3">{vehicle_type.label}</Label>
                              </td>
                              <td>
                                <Input
                                  type="text"
                                  autocomplete="nofill"
                                  name="count"
                                  disabled={this.state.isDisplayDetail}
                                  value={vehicle_type.count}
                                  style={{ width: '100px', marginLeft: '45px' }}
                                  onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type, i)}
                                  placeholder=" " />
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                    {this.state.countErrorMsg && <div className="error" style={{ marginLeft: '185px' }}>*Please enter count</div>}
                  </Col>
                </Row>
                <Row id="percentage_retread" style={{ borderTop: 'solid 1px #ced4da', margin: '3px' }}>
                  <Col xl="12" md="12" xs="12" className="mt-3">
                    <Row>
                      <Col xl="4" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2 font-weight-bold">Total number of Wheels<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12" style={{ marginTop: '8px' }}>
                        {/* {vehicles.lcv.reduce((acc, curr) => acc + +curr.count, 0)} */}
                        {this.getTotalTyre(vehicles.lcv)}
                        {/* <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="percentage_retread"
                            value={controls.percentage_retread.value}
                            style={{ width: '100px' }}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                          {controls.percentage_retread.showErrorMsg && <div className="error">*Please enter retreading %.</div>}
                        </FormGroup> */}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            }
            {
              (this.props.vehicle_type === 'pickup' || this.props.vehicle_type === 'icv') &&
              <>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="12" md="12" xs="12">

                    {
                      vehicles[this.props.vehicle_type].map((vehicle_type, i) => (
                        (vehicle_type.type !== 'lead_type' && vehicle_type.type !== "bias_potential_average_per_month" &&
                          vehicle_type.type !== 'radial_potential_average_per_month' && vehicle_type.type !== 'three_point_five_seven_point_five_t_gvw' &&
                          vehicle_type.type !== 'seven_point_five_twelve_t_gvw' && vehicle_type.type !== 'two_to_three_point_five_t_gvw') &&

                        <Row>
                          <Col xl="6" md="12" xs="12">
                            <Label for="company_name" className="mt-xl-3">Vehicle Count<span className="required-field">*</span></Label>
                          </Col>
                          <Col xl="6" md="12" xs="12">
                            <FormGroup>
                              <Input
                                type="text"
                                autocomplete="nofill"
                                name="count"
                                value={vehicle_type.count}
                                onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type, i)}
                                disabled={this.state.isDisplayDetail}
                                placeholder=" " />
                            </FormGroup>
                            {this.state.countErrorMsg && <div className="error" style={{ marginTop: '-10px;' }}>*Please enter count</div>}
                          </Col>
                        </Row>
                      ))
                    }
                  </Col>
                </Row>

                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="6" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Bias Potential Avg Per Year<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="bias_potential_average_per_month"
                            value={controls.bias_potential_average_per_month.value}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Col>
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="6" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Radial Potential Avg Per Year<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="6" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            disabled={this.state.isDisplayDetail}
                            name="radial_potential_average_per_month"
                            value={controls.radial_potential_average_per_month.value}
                            onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                            placeholder=" " />
                        </FormGroup>
                      </Col>

                      <Col xl="12" md="12" xs="12">
                        {controls.bias_potential_average_per_month.showErrorMsg && controls.radial_potential_average_per_month.showErrorMsg && <div className="error" style={{ marginTop: '-10px' }}>*Please enter bias potential avg per year or radial potential avg per year </div>}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <Label for="company_name">No Of Tube Tyre<span className="required-field">*</span></Label>
                    <FormGroup>
                      <Input
                        type="text"
                        autocomplete="nofill"
                        disabled={this.state.isDisplayDetail || this.state.isDisableNoOfTubeAndTubeLess}
                        name="no_of_tube_tyre"
                        value={controls.no_of_tube_tyre.value}
                        onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                        placeholder=" " />
                    </FormGroup>
                  </Col>
                  <Col xl="6" md="12" xs="12">
                    <Label for="company_name">No Of Tubeless Tyre<span className="required-field">*</span></Label>
                    <FormGroup>
                      <Input
                        type="text"
                        autocomplete="nofill"
                        disabled={this.state.isDisplayDetail || this.state.isDisableNoOfTubeAndTubeLess}
                        name="no_of_tubeless_tyre"
                        value={controls.no_of_tubeless_tyre.value}
                        onChange={(e) => this.onChangeVehicle(e, this.props.vehicle_type)}
                        placeholder=" " />
                    </FormGroup>
                  </Col>
                  {controls.no_of_tube_tyre.showErrorMsg && controls.no_of_tubeless_tyre.showErrorMsg &&
                    <Col xl="12" md="12" xs="12">
                      <div className="error" style={{ marginTop: '-10px' }}>*Please enter no of tube tyre or no of tubeless tyre </div>
                    </Col>
                  }
                  <Col xl="12" md="12" xs="12">
                    <FormGroup>
                      <Label for="company_name">Avg Monthly running(KMs)</Label>
                      <select className="form-control" name="average_mothly_usage" value={controls.average_mothly_usage.value}
                        onChange={(e) => this.onChangeVehicle(e, 'truck')} disabled={this.state.isDisplayDetail}>
                        <option value="" selected>Select</option>
                        {
                          MonthlyRunningData.map((MonthlyRunning, j) => (
                            <option className="text-capitalize" value={MonthlyRunning} key={MonthlyRunning}>{MonthlyRunning}</option>
                          ))
                        }
                      </select>
                    </FormGroup>
                  </Col>
                </Row>
              </>
            }
            {
              (this.props.vehicle_type === 'retread' && this.state.vehicles.retread &&
                Object.keys(this.state.vehicles.retread).length > 0) &&
              <>
                <Row style={{ margin: '3px' }} id="AddEditFleetVehicle">
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="5" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Retreading Practice<span className="required-field">*</span></Label>
                      </Col>
                      <Col xl="4" md="12" xs="12">
                        <FormGroup>
                          <select className="form-control" name="retreading_practice"
                            value={vehicles.retread.retreading_practice.value} disabled={this.state.isDisplayDetail}
                            onChange={this.onChangeRetrade}>
                            <option value="" selected disabled>Select</option>
                            <option value="retreads">Retreads</option>
                            <option value="sells casings">Sells Casings</option>
                          </select>
                        </FormGroup>
                        {vehicles.retread.retreading_practice.showErrorMsg && <div className="error">*Please select retreading practice.</div>}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="5" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Major Tread Used{vehicles.retread.retreading_practice.value === 'retreads' && <span className="required-field">*</span>}</Label>
                      </Col>
                      <Col xl="4" md="12" xs="12">
                        <FormGroup>
                          <select className="form-control" name="major_tread_used"
                            value={vehicles.retread.major_tread_used.value} disabled={this.state.isDisplayDetail ||
                              vehicles.retread.retreading_practice.value === 'sells casings'}
                            onChange={this.onChangeRetrade}>
                            <option value="" selected disabled>Select</option>
                            <option value="JK Tyre">JK Tyre</option>
                            <option value="Indag">Indag</option>
                            <option value="Apollo">Apollo</option>
                            <option value="MRF">MRF</option>
                            <option value="ELGI">ELGI</option>
                            <option value="TVS">TVS</option>
                            <option value="Other">Other</option>
                          </select>
                        </FormGroup>
                        {vehicles.retread.major_tread_used.showErrorMsg && <div className="error">*Please select major tread used.</div>}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="5" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Retreading Franchise{vehicles.retread.retreading_practice.value === 'retreads' && <span className="required-field">*</span>}</Label>
                      </Col>
                      <Col xl="4" md="12" xs="12">
                        <FormGroup>
                          <select className="form-control" name="retreading_franchise"
                            value={vehicles.retread.retreading_franchise.value}
                            disabled={this.state.isDisplayDetail || vehicles.retread.retreading_practice.value === 'sells casings'}
                            onChange={this.onChangeRetrade}>
                            <option value="" selected disabled>Select</option>
                            <option value="JK Tyre">JK Tyre</option>
                            <option value="Indag">Indag</option>
                            <option value="Apollo">Apollo</option>
                            <option value="MRF">MRF</option>
                            <option value="ELGI">ELGI</option>
                            <option value="TVS">TVS</option>
                            <option value="Private">Private</option>
                          </select>
                        </FormGroup>
                        {vehicles.retread.retreading_franchise.showErrorMsg && <div className="error">*Please select retreading franchise.</div>}
                      </Col>
                    </Row>
                  </Col>
                  <Col xl="12" md="12" xs="12">
                    <Row>
                      <Col xl="5" md="12" xs="12">
                        <Label for="company_name" className="mt-xl-2">Tyres Retread Per Month{vehicles.retread.retreading_practice.value === 'retreads' && <span className="required-field">*</span>}</Label>
                      </Col>
                      <Col xl="4" md="12" xs="12">
                        <FormGroup>
                          <Input
                            type="text"
                            autocomplete="nofill"
                            name="tyres_per_month"
                            disabled={this.state.isDisplayDetail || vehicles.retread.retreading_practice.value === 'sells casings'}
                            value={vehicles.retread.tyres_per_month.value}
                            onChange={this.onChangeRetrade}
                            placeholder=" " />
                        </FormGroup>
                        {vehicles.retread.tyres_per_month.showErrorMsg && <div className="error">*Please enter tyres retread per month.</div>}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </>
            }
          </div>
          {
            !this.state.isDisplayDetail &&
            <Row className="c-top-15 custom-drawer-footer" style={{ marginLeft: '0px', marginRight: '0px' }}>
              <Col>
                <Button
                  //  disabled={!isValidForm} 
                  type="button"
                  // onClick={this.saveSale}
                  className="mb-1 mr-1 btn-pill action-button profile-save-button pull-right"
                  color="warning"
                  style={{ cursor: 'pointer' }}
                  onClick={this.submit}
                >Submit
                </Button>
              </Col>
            </Row>
          }
        </div>
      </>
    );
  }
}

export default AddEditFleetVehicle;